var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlannjaLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "362.67pt",
    height: "80.75pt",
    viewBox: "0 0 362.67 80.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 198 16 L 220 16 L 220 80.75 L 198 80.75 Z M 198 16 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 284 0 L 362.671875 0 L 362.671875 67 L 284 67 Z M 284 0 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#FFFFFF",
      fillOpacity: 1
    },
    d: "M 23.574219 39.140625 C 27.453125 39.140625 30.277344 37.585938 30.277344 33.210938 C 30.277344 28.480469 24.914063 27.847656 21.386719 27.847656 L 16.65625 27.847656 L 16.65625 39.140625 Z M 0 66.804688 L 0 15.988281 L 24.488281 15.988281 C 39.097656 15.988281 46.15625 22.695313 46.15625 33.140625 C 46.15625 44.078125 39.664063 50.996094 25.054688 50.996094 L 16.65625 50.996094 L 16.65625 66.804688 L 0 66.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#FFFFFF",
      fillOpacity: 1
    },
    d: "M 49.226563 66.804688 L 49.226563 15.988281 L 63.90625 15.988281 L 63.90625 66.804688 L 49.226563 66.804688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#FFFFFF",
      fillOpacity: 1
    },
    d: "M 95.136719 66.804688 L 94.429688 62.851563 C 90.265625 66.734375 86.03125 67.863281 80.527344 67.863281 C 73.539063 67.863281 67.328125 64.40625 67.328125 56.710938 C 67.328125 39.914063 93.652344 47.535156 93.652344 40.621094 C 93.652344 37.9375 90.40625 37.585938 88.855469 37.585938 C 86.808594 37.585938 84.054688 38.007813 83.703125 41.183594 L 69.589844 41.183594 C 69.589844 33.351563 75.164063 28.761719 89.773438 28.761719 C 107.273438 28.761719 108.332031 35.257813 108.332031 44.078125 L 108.332031 61.371094 C 108.332031 63.488281 108.402344 64.546875 110.308594 66.097656 L 110.308594 66.804688 Z M 93.652344 50.429688 C 88.855469 52.761719 82.503906 51.632813 82.503906 56.429688 C 82.503906 58.265625 84.269531 59.535156 87.160156 59.535156 C 92.3125 59.535156 94.007813 55.511719 93.652344 50.429688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#FFFFFF",
      fillOpacity: 1
    },
    d: "M 113.945313 29.824219 L 127.355469 29.824219 L 127.355469 35.609375 C 130.675781 31.164063 134.273438 28.761719 139.847656 28.761719 C 149.589844 28.761719 154.175781 34.480469 154.175781 44.644531 L 154.175781 66.804688 L 139.496094 66.804688 L 139.496094 47.253906 C 139.496094 43.585938 138.507813 40.339844 134.34375 40.339844 C 129.828125 40.339844 128.628906 43.230469 128.628906 47.960938 L 128.628906 66.804688 L 113.945313 66.804688 L 113.945313 29.824219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#FFFFFF",
      fillOpacity: 1
    },
    d: "M 159.632813 29.824219 L 173.042969 29.824219 L 173.042969 35.609375 C 176.359375 31.164063 179.960938 28.761719 185.535156 28.761719 C 195.273438 28.761719 199.859375 34.480469 199.859375 44.644531 L 199.859375 66.804688 L 185.183594 66.804688 L 185.183594 47.253906 C 185.183594 43.585938 184.195313 40.339844 180.03125 40.339844 C 175.511719 40.339844 174.3125 43.230469 174.3125 47.960938 L 174.3125 66.804688 L 159.632813 66.804688 L 159.632813 29.824219 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#FFFFFF",
      fillOpacity: 1
    },
    d: "M 219.761719 29.824219 L 219.761719 63.277344 C 219.761719 72.449219 218.84375 80.75 205.148438 80.75 C 203.105469 80.75 201.058594 80.679688 198.792969 80.539063 L 198.792969 69.402344 C 204.234375 69.402344 205.078125 68.355469 205.078125 63.277344 L 205.078125 29.824219 Z M 205.078125 27.171875 L 205.078125 16.722656 L 219.761719 16.722656 L 219.761719 27.171875 L 205.078125 27.171875 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#FFFFFF",
      fillOpacity: 1
    },
    d: "M 251.527344 66.804688 L 250.820313 62.851563 C 246.660156 66.734375 242.425781 67.863281 236.921875 67.863281 C 229.933594 67.863281 223.722656 64.40625 223.722656 56.710938 C 223.722656 39.914063 250.046875 47.535156 250.046875 40.621094 C 250.046875 37.9375 246.800781 37.585938 245.246094 37.585938 C 243.199219 37.585938 240.449219 38.007813 240.097656 41.183594 L 225.980469 41.183594 C 225.980469 33.351563 231.554688 28.761719 246.164063 28.761719 C 263.664063 28.761719 264.726563 35.257813 264.726563 44.078125 L 264.726563 61.371094 C 264.726563 63.488281 264.796875 64.546875 266.699219 66.097656 L 266.699219 66.804688 Z M 250.046875 50.429688 C 245.246094 52.761719 238.894531 51.632813 238.894531 56.429688 C 238.894531 58.265625 240.660156 59.535156 243.554688 59.535156 C 248.707031 59.535156 250.398438 55.511719 250.046875 50.429688 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#FFFFFF",
      fillOpacity: 1
    },
    d: "M 324.027344 13.84375 L 335.132813 0.0390625 L 362.671875 34.421875 L 362.585938 66.8125 L 330.121094 66.8125 L 330.152344 37.363281 L 323.996094 29.71875 L 317.699219 37.140625 L 317.785156 66.804688 L 285.023438 66.8125 L 284.972656 34.5625 L 312.371094 0.00390625 Z M 312.371094 15.8125 L 295.769531 36.707031 L 295.769531 57.207031 L 306.992188 57.324219 L 307.046875 34.300781 L 317.304688 21.761719 Z M 335.273438 15.949219 L 330.121094 21.710938 L 330.238281 21.761719 L 340.460938 34.703125 L 340.480469 57.03125 L 352.085938 57.097656 L 352.085938 36.707031 L 335.273438 15.949219 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannjaLogoWhite);
export default __webpack_public_path__ + "static/media/plannja_logo_white.53b2cb3cd3054696b1a1d9350b93722f.svg";
export { ForwardRef as ReactComponent };